import Explore from "./explore.svg";
import NavigateIcon from "./navigate_icon.svg";
import NavigationFeedbackIcon from "./navigation_feedback_icon.svg";
import ExploreActive from "./explore_active.svg";
import Profile from "./profile.svg";
import ProfileActive from "./profile_active.svg";
import Info from "./info.svg";
import Logo from "./logo.svg";
import CollegeGreen from "./college_green.svg";
import CollegeYellow from "./college_yellow.svg";
import CollegeGrey from "./college_grey.svg";
import CollegeRed from "./college_red.svg";
import RestrauntGreen from "./food_drink_green.svg";
import RestrauntYellow from "./food_drink_yellow.svg";
import RestrauntRed from "./food_drink_red.svg";
import RestrauntGrey from "./food_drink_grey.svg";
import SchoolGreen from "./school_green.svg";
import SchoolGrey from "./school_grey.svg";
import SchoolRed from "./school_red.svg";
import schoolYellow from "./school_yellow.svg";
import WorkplaceGreen from "./workplace_green.svg";
import WorkplaceYellow from "./workplace_yellow.svg";
import WorkplaceRed from "./workplace_red.svg";
import WorkplaceGrey from "./workplace_grey.svg";
import AutomotiveGreen from "./automotive_green.svg";
import AutomotiveYellow from "./automotive_yellow.svg";
import AutomotiveRed from "./automotive_red.svg";
import AutomotiveGrey from "./automotive_grey.svg";
import EntertainmentGreen from "./entertainment_green.svg";
import EntertainmentYellow from "./entertainment_yellow.svg";
import EntertainmentRed from "./entertainment_red.svg";
import EntertainmentGrey from "./entertainment_grey.svg";
import HealthGreen from "./health_green.svg";
import HealthYellow from "./health_yellow.svg";
import HealthRed from "./health_red.svg";
import HealthGrey from "./health_grey.svg";
import ShoppingGreen from "./shopping_green.svg";
import ShoppingYellow from "./shopping_yellow.svg";
import ShoppingRed from "./shopping_red.svg";
import ShoppingGrey from "./shopping_grey.svg";
import LodgeGreen from "./lodge_green.svg";
import LodgeYellow from "./lodge_yellow.svg";
import LodgeRed from "./lodge_red.svg";
import LodgeGrey from "./lodge_grey.svg";
import NatureGreen from "./nature_green.svg";
import NatureYellow from "./nature_yellow.svg";
import NatureRed from "./nature_red.svg";
import NatureGrey from "./nature_grey.svg";
import GovernmentGreen from "./government_green.svg";
import GovernmentYellow from "./government_yellow.svg";
import GovernmentRed from "./government_red.svg";
import GovernmentGrey from "./government_grey.svg";
import SportsGreen from "./sports_green.svg";
import SportsYellow from "./sports_yellow.svg";
import SportsRed from "./sports_red.svg";
import SportsGrey from "./sports_grey.svg";
import WorshipGreen from "./worship_green.svg";
import WorshipYellow from "./worship_yellow.svg";
import WorshipRed from "./worship_red.svg";
import WorshipGrey from "./worship_grey.svg";
import FinanceGreen from "./finance_green.svg";
import FinanceYellow from "./finance_yellow.svg";
import FinanceRed from "./finance_red.svg";
import FinanceGrey from "./finance_grey.svg";
import ServiceGreen from "./service_green.svg";
import ServiceYellow from "./service_yellow.svg";
import ServiceRed from "./service_red.svg";
import ServiceGrey from "./service_grey.svg";
import CultureGreen from "./culture_green.svg";
import CultureYellow from "./culture_yellow.svg";
import CultureRed from "./culture_red.svg";
import CultureGrey from "./culture_grey.svg";
import Video from "./video.png";
import WheelChair from "./wheelchair.svg";
import Entrance from "./entrance.svg";
import Exit from "./exit.svg";
import railGreen from "./rail_green.svg";
import railYellow from "./rail_yellow.svg";
import railRed from "./rail_red.svg";
import railGrey from "./rail_grey.svg";
import metroGreen from "./metro_green.svg";
import metroYellow from "./metro_yellow.svg";
import metroRed from "./metro_red.svg";
import metroGrey from "./metro_grey.svg";
import airportGreen from "./airport_green.svg";
import airportYellow from "./airport_yellow.svg";
import airportRed from "./airport_red.svg";
import airportGrey from "./airport_grey.svg";
import eyeoff from "./eye_off.svg";
import eyeon from "./eye-on.svg";
import LogoWhite from "./logo_white.svg";
import Alert from "./alert.svg";
import Tick from "./tick.svg";
import Edit from "./edit.svg";
import Update from "./update.svg";
import placeImg from "./vr.jpg";
import Contributor from "./contributor.svg";
import Accessibility from "./accessibility.svg";
import Draft from "./draft.svg";
import ContributionsMade from "./contribution_made.svg";
import Bell from "./bell.svg";
import Reload from "./reload.svg";
import Seleted from "./selected.svg";
import NotSelected from "./not_selected.svg";
import Notification from "./notification.svg";
import NoNotes from "./no_notes.svg";
import NoNotification from "./no_notification.svg";
import NewContributor from "./new_contributor.png";
import ActiveContributor from "./active_contributor.png";
import TrustedContributor from "./trusted_contributor.png";
import HighlyTrusted from "./highly_trusted.png";
import TrustScore from "./trust_score_info.png";
import PalladiumNameGuide from "./palladium_nameguide.png";
import BuildingNameGuide from "./building_nameguide.png";
import SchoolFilter from "./school_filter.svg";
import CollegeFilter from "./college_filter.svg";
import AirportFilter from "./airport_filter.svg";
import RestaurantFilter from "./restaurant_filter.svg";
import MetroFilter from "./metro_filter.svg";
import RailwayFilter from "./railway_filter.svg";
import WorkPlaceFilter from "./workplace_filter.svg";
import cupIcon from "./cup_icon.png";
import EmailVerified from "./email_verified.svg";
import Expired from "./expired.svg";
import AlreadyVerified from "./already_verified.svg";
import Resend from "./resend.svg";
import CantVerified from "./cant_verified.svg";
import NotVerified from "./not_verified.svg";
import Building from "./building.jpg";
import Cam from "./cam.png"

const Icons = {
  Explore,
  ExploreActive,
  Profile,
  ProfileActive,
  Info,
  Logo,
  Cam,
  CollegeGreen,
  CollegeYellow,
  CollegeGrey,
  CollegeRed,
  RestrauntGreen,
  RestrauntYellow,
  RestrauntRed,
  RestrauntGrey,
  SchoolGreen,
  SchoolGrey,
  SchoolRed,
  schoolYellow,
  WorkplaceGreen,
  WorkplaceYellow,
  WorkplaceRed,
  WorkplaceGrey,
  AutomotiveGreen,
  AutomotiveYellow,
  AutomotiveRed,
  AutomotiveGrey,
  EntertainmentGreen,
  EntertainmentYellow,
  EntertainmentRed,
  EntertainmentGrey,
  HealthGreen,
  HealthYellow,
  HealthRed,
  HealthGrey,
  ShoppingGreen,
  ShoppingYellow,
  ShoppingRed,
  ShoppingGrey,
  LodgeGreen,
  LodgeYellow,
  LodgeRed,
  LodgeGrey,
  NatureGreen,
  NatureYellow,
  NatureRed,
  NatureGrey,
  GovernmentGreen,
  GovernmentYellow,
  GovernmentRed,
  GovernmentGrey,
  SportsGreen,
  SportsYellow,
  SportsRed,
  SportsGrey,
  WorshipGreen,
  WorshipYellow,
  WorshipRed,
  WorshipGrey,
  FinanceGreen,
  FinanceYellow,
  FinanceRed,
  FinanceGrey,
  ServiceGreen,
  ServiceYellow,
  ServiceRed,
  ServiceGrey,
  CultureGreen,
  CultureYellow,
  CultureRed,
  CultureGrey,
  Video,
  WheelChair,
  Entrance,
  Exit,
  railGreen,
  railYellow,
  railRed,
  railGrey,
  metroGreen,
  metroYellow,
  metroRed,
  metroGrey,
  airportGreen,
  airportYellow,
  airportRed,
  airportGrey,
  eyeoff,
  eyeon,
  LogoWhite,
  Alert,
  Tick,
  Edit,
  Update,
  placeImg,
  Contributor,
  Accessibility,
  Draft,
  ContributionsMade,
  Bell,
  Reload,
  Seleted,
  NotSelected,
  Notification,
  NoNotes,
  NoNotification,
  NewContributor,
  ActiveContributor,
  TrustedContributor,
  HighlyTrusted,
  TrustScore,
  SchoolFilter,
  CollegeFilter,
  AirportFilter,
  RestaurantFilter,
  MetroFilter,
  RailwayFilter,
  WorkPlaceFilter,
  cupIcon,
  EmailVerified,
  Expired,
  AlreadyVerified,
  Resend,
  CantVerified,
  NotVerified,
  NavigateIcon,
  NavigationFeedbackIcon,
  Building,
  PalladiumNameGuide,
  BuildingNameGuide
};

export default Icons;
